import axios from 'axios';

const apiUrl = process.env.NODE_ENV === 'development' ? 'https://baumlanus.apibaumlanus.xyz' : 'https://baumlanus.apibaumlanus.xyz';

const instance = axios.create({
  baseURL: apiUrl
});

export default instance;